import { createApiRef } from '@backstage/core-plugin-api';

export interface Permissions {
  read: boolean;
}

export interface AgenticMarketplaceApi {
  checkPermissions(): Promise<Permissions>;
}

export const agenticMarketplaceApiRef = createApiRef<AgenticMarketplaceApi>({
  id: 'plugin.agentic-marketplace.service',
});
